var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"success","elevation":"1","small":"","href":`https://www.kpi.or.kr/www/`,"target":"_blank"}},[_vm._v(" 물가정보 바로가기 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }